import React from "react";
import SlidingButton from "./SlidingButton";
import CurrencyInput from "./CurrencyInput";

const options = [
    { key: "yes", value: "Yes" },
    { key: "no", value: "No" },
];

function AddSIMCard(props) {
    const { onAddSIM, onInputChange, value, placeholder, addSim } = props;
    return (
        <div>
            <SlidingButton
                handleChange={(_e, v) => onAddSIM("sim_card_default", v)}
                title="Add SIM Card?"
                value={addSim}
                options={options}
            />
            {addSim == "yes" && (
                <CurrencyInput
                    label="Monthly Wireless"
                    onChange={onInputChange}
                    placeholder={placeholder}
                    name={"sim_card_monthly_default"}
                    value={value}
                    type="number"
                />
            )}
        </div>
    );
}

export default AddSIMCard;
